import { validationContext } from 'validx'
import type { FutureTaxCreditTaxRefundDeliveryMethod } from './TaxRefundDeliveryMethod'

/**
 * View model for the future tax credit delivery method, which has nothing to
 * edit.
 */
export class FutureTaxCreditDeliveryMethodEditorViewModel {
  readonly validation = validationContext(this, {})

  /**
   * Maps the state of the VM to {@link FutureTaxCreditTaxRefundDeliveryMethod}.
   */
  toDeliveryMethod(): FutureTaxCreditTaxRefundDeliveryMethod {
    return { type: 'FutureTaxCredit' }
  }
}
